module.exports = JSON.parse('{"Load files":"加载文件","Load folders":"加载文件夹"}')